import { List } from '@mui/material';
import styled from 'styled-components';

export const NotificationText = styled.div`
  color: ${(props) => props.theme.newPalette.neutral.N500};
  font-family: ${(props) => props.theme.typography.fontFamily};
  margin-bottom: 10px;
`;

export const EmptyNotifications = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  background: ${(props) => props.theme.newPalette.neutral.N0};
  min-width: 370px;
  justify-content: center;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
export const NotificationTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  align-content: start;
  cursor: pointer;
`;

export const NotificationsButton = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
  color: ${(props) => props.theme.atlas.semantic.color.action.link.default};
  margin: 5px;
`;

export const ClearNotificationContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
`;

export const ClearNotificationsButton = styled(NotificationsButton)<{
  notificationsOpen?: boolean;
  newNavEnabled?: boolean;
}>`
  justify-content: flex-end;
  margin: 20px 15px 10px 20px;
  opacity: ${(props) =>
    props.newNavEnabled && (props.notificationsOpen ? '1' : '0')};
  ${(props) =>
    props.newNavEnabled &&
    `transition: opacity ${props.notificationsOpen ? '0.4s' : '0.3s'};
  transition-delay: ${props.notificationsOpen ? '0.2s' : '0s'};`}
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  color: ${(props) => props.theme.atlas.semantic.color.action.link.default};
`;

export const StyledList = styled(List)`
  background-color: ${(props) => props.theme.newPalette.neutral.N0};
  height: 100%;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: right;
  }
`;

export const EmptyReporterNotifications = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: ${(props) => props.theme.newPalette.neutral.N0};
  min-width: 370px;
  justify-content: center;
  align-items: center;
`;

export const EmptyReporterNotificationsTop = styled.div`
  margin: 20px;
  width: 100%;
  align-items: start;
`;
export const EmptyReporterNotificationsState = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const NavbarDrawerTopOptions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  background-color: ${(props) => props.theme.newPalette.neutral.N0};

  & ${NotificationsButton} {
    margin: 0;
  }
`;

export const ActualNotificationsContainer = styled.div`
  background-color: ${(props) => props.theme.newPalette.neutral.N0};
  height: 100%;
`;
